import axiosInstance from "../interceptors/axiosInterceptor";

export const UpdateBannerImage = async (image) => {
  try {
    // Create a FormData object
    const formData = new FormData();
    formData.append("image", image);

    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BASE_URL}/api/admin/homePageSettings/bannerImage/upload`,
      formData, // Send FormData instead of JSON
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the proper content type
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error("Failed to update Banner image. Please try again later.");
  }
};

export const FetchBannerImage = async () => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_BASE_URL}/api/admin/homePageSettings/bannerImage/fetch`
    );

    // Assuming the API returns a URL in response.data.image
    return response.data;
  } catch (error) {
    throw new Error(
      "Failed to fetch the banner image. Please try again later."
    );
  }
};
